import React from 'react';
import { createRoot } from 'react-dom/client';

import { ServiceProvider } from '@boozallen-uip/uswds-react-core';

import App from './App';
import * as serviceWorker from './serviceWorker';

import './styles.scss';
import './styles/header.scss';
import './styles/index.css'

function reactInit() {
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <ServiceProvider>
      <App />
    </ServiceProvider>
  );

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
}

reactInit();
